import React from 'react'
import PropTypes from 'prop-types'
import UnitCard from './UnitCard'

const SquadMonitor = (props) => {
    const {
        squadUnits, handleEdit, handleDelete, children,
    } = props

    return (
        <div className="squad__monitor">
            <h2 className="squad__monitor--title">
                <span>Your current Squad</span>
                {React.Children.map(children, child => child)}
            </h2>

            <div className="squad__monitor--listing">
                {
                    squadUnits.map(baseUnit => (
                        <UnitCard
                            key={baseUnit.ID}
                            inSquad
                            baseUnit={baseUnit}
                            clickAdd={{ enabled: false }}
                            clickEdit={handleEdit}
                            clickDelete={handleDelete}
                        />
                    ))
                }
            </div>
        </div>
    )
}

SquadMonitor.propTypes = {
    squadUnits: PropTypes.array.isRequired,
    handleEdit: PropTypes.object.isRequired,
    handleDelete: PropTypes.object.isRequired,
    children: PropTypes.node,
}

SquadMonitor.defaultProps = {
    children: [],
}

export default SquadMonitor
